import { FlightCategoryListPayloadSchema } from 'src/models/flight-category.model';
import { httpClient } from 'src/libraries/http.library';

const client = httpClient();

const services = {
  listGET: async () => {
    return client.get(
      '/flightCategories',
      { limit: 0 },
      FlightCategoryListPayloadSchema
    );
  },
};

export default services;
